import { theme } from '@theme';

export const helpCenterCategoryItem = {
  display: 'flex',
  width: '100%',
  color: theme.palette.common.darkGrey12,
  marginLeft: '-32px',
  marginRight: '-32px',
  padding: '12px 32px',
  cursor: 'pointer',
  borderLeft: `4px solid transparent`,
  borderRadius: 0,
  textTransform: 'none',
  justifyContent: 'flex-start',
  minWidth: 'auto',
  fontSize: '16px',
  fontWeight: 400,
  lineHeight: '24px',
  '&:hover': {
    backgroundColor: 'transparent'
  }
};

export const helpCenterCategoryItemActive = {
  color: theme.palette.common.primaryDark,
  fontWeight: 600,
  borderLeftColor: theme.palette.common.buttonPrimaryDefault
};
